export default __webpack_public_path__ + "static/media/bannerCrisBarros.8443f5c6.svg";